<template>
  <div class="field-file position-relative">
    <!-- Label del campo (si showLabel es true) -->
    <small
      v-if="showLabel && field.label"
      :for="computedFieldId"
      class="form-label w-100"
    >
      <strong>
        {{ $t(field.label) }}
      </strong>
    </small>
    <br v-if="showLabel && field.label" />

    <!-- MODO FILTRO -->
    <FilterFieldFile
      v-if="mode === 'edit' && isFilter"
      :field="field"
      :value="value"
      :fieldId="computedFieldId"
      :filterOperator="filterOperator"
      @input="$emit('input', $event)"
      @filter-operator-change="$emit('filter-operator-change', $event)"
    />

    <!-- MODO EDIT -->
    <EditFieldFile
      v-else-if="effectiveFieldMode === 'edit'"
      :field="field"
      :value="value"
      :fieldId="computedFieldId"
      :editingFields="editingFields"
      :disableLock="disableLock"
      :calculated="calculated"
      @input="$emit('input', $event)"
      @uploading="$emit('uploading', $event)"
      @update:editingFields="$emit('update:editingFields', $event)"
    />

    <!-- MODO VIEW -->
    <ViewFieldFile
      v-else-if="effectiveFieldMode === 'view'"
      :field="field"
      :value="value"
      :item="item"
      :modelName="modelName"
      :isGroupModel="isGroupModel"
    />
  </div>
</template>

<script>
import EditFieldFile from "./file/editField.vue";
import ViewFieldFile from "./file/viewField.vue";
import FilterFieldFile from "./file/filterField.vue";
import fieldEditableByMixin from "@/mixins/fieldEditableByMixin";

export default {
  name: "FieldFile",
  mixins: [fieldEditableByMixin],
  components: {
    EditFieldFile,
    ViewFieldFile,
    FilterFieldFile,
  },
  props: {
    field: {
      type: Object,
      required: true,
    },
    value: {
      type: [String, Array],
      default: null,
    },
    mode: {
      type: String,
      required: true,
      validator: (value) => ["edit", "view"].includes(value),
    },
    fieldId: {
      type: String,
      default: null,
    },
    editingFields: {
      type: String,
      default: "",
    },
    item: {
      type: Object,
      default: null,
    },
    modelName: {
      type: String,
      default: "",
    },
    isGroupModel: {
      type: Boolean,
      default: false,
    },
    showLabel: {
      type: Boolean,
      default: false,
    },
    disableLock: {
      type: Boolean,
      default: false,
    },
    calculated: {
      type: Boolean,
      default: false,
    },
    isFilter: {
      type: Boolean,
      default: false,
    },
    filterOperator: {
      type: String,
      default: "=",
    },
  },
  computed: {
    computedFieldId() {
      return this.fieldId || `field-file-${this.field.key}`;
    },
  },
};
</script>

<style scoped>
.field-file {
  width: 100%;
}
</style>
